module.exports = __webpack_public_path__ + "media/src/images/zu_exp_04-a7485be0754501cefe4735bcdc87f690.gif";